var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "spotUseBox" }, [
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText2 aligned" }, [_vm._v(" 预约方式 ")]),
      _c(
        "div",
        {
          staticClass: "columnText3",
          staticStyle: { flex: "1", "text-align": "center" },
        },
        [
          _vm._v(
            _vm._s(
              _vm.datas.otherStockData.appointment == 1
                ? "无需预约"
                : _vm.datas.otherStockData.appointment == 2
                ? "需预约"
                : "未填写"
            )
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText2 aligned" }, [_vm._v(" 入园时间 ")]),
      _c(
        "div",
        {
          staticClass: "columnText3",
          staticStyle: { flex: "1", "text-align": "center" },
        },
        [
          _vm._v(
            _vm._s(
              _vm.datas.otherStockData.appointmentMethod
                ? _vm.datas.otherStockData.appointmentMethod
                : "未填写"
            )
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText2 aligned" }, [_vm._v(" 取票方式 ")]),
      _c(
        "div",
        {
          staticClass: "columnText3",
          staticStyle: { flex: "1", "text-align": "center" },
        },
        [
          _vm._v(
            _vm._s(
              _vm.datas.otherStockData.ticketMethod == 1
                ? "无需取票"
                : _vm.datas.otherStockData.ticketMethod == 2
                ? "需取票"
                : "未填写"
            )
          ),
        ]
      ),
    ]),
    _vm.datas.otherStockData.ticketMethod == 2
      ? _c("div", [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "columnText2 aligned" }, [
              _vm._v(" 取票地址 "),
            ]),
            _c(
              "div",
              {
                staticClass: "columnText3",
                staticStyle: { flex: "1", "text-align": "center" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.datas.otherStockData.address
                      ? _vm.datas.otherStockData.address
                      : "未填写"
                  )
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "columnText2 aligned" }, [
              _vm._v(" 取票时间段 "),
            ]),
            _c(
              "div",
              {
                staticClass: "columnText3",
                staticStyle: { flex: "1", "text-align": "center" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.datas.otherStockData.ticketTime
                      ? _vm.datas.otherStockData.ticketTime
                      : "未填写"
                  )
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "columnText2 aligned" }, [
              _vm._v(" 取票联系人信息 "),
            ]),
            _c(
              "div",
              {
                staticClass: "columnText3",
                staticStyle: { flex: "1", "text-align": "center" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.datas.otherStockData.ticketContactInfo
                      ? _vm.datas.otherStockData.ticketContactInfo
                      : "未填写"
                  )
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c("div", { staticClass: "columnText4 aligned" }, [
          _vm._v(" 入园时间段 "),
        ]),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            "placeholder-class": "placeholder",
            placeholder: "请在此处填写可入园时间段，如有季节区分，请注明",
            type: "text",
          },
          model: {
            value: _vm.datas.otherStockData.joinTime,
            callback: function ($$v) {
              _vm.$set(_vm.datas.otherStockData, "joinTime", $$v)
            },
            expression: "datas.otherStockData.joinTime",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c("div", { staticClass: "columnText4 aligned" }, [
          _vm._v(" 使用说明文字描述 "),
        ]),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            "placeholder-class": "placeholder",
            placeholder: "请输入使用说明文字描述",
            type: "text",
          },
          model: {
            value: _vm.datas.useExplain,
            callback: function ($$v) {
              _vm.$set(_vm.datas, "useExplain", $$v)
            },
            expression: "datas.useExplain",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }